export default "__VITE_ASSET__dgvOTByo__"